<template>
  <div class="dropdown-manager-container">
    <v-container fluid>
      <v-row class="pa-7" justify="center">
        <h1 class="page-title">DROPDOWN MANAGER</h1>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="10">
          <v-card class="main-card pa-6">
            <v-overlay :value="loading">
              <v-progress-circular indeterminate size="64" />
            </v-overlay>

            <!-- Engineers Section -->
            <div class="section-header mb-4">
              <h2 class="section-title">ENGINEERS</h2>
              <div class="section-divider"></div>
            </div>
            <v-row class="mb-6">
              <v-col cols="12" md="8">
                <v-text-field v-model="newEngineer" label="Add Engineer" dense outlined prepend-inner-icon="mdi-account-hard-hat" @keyup.enter="addItem('engineers', 'newEngineer')" class="nexus-input" />
              </v-col>
              <v-col cols="12" md="4">
                <v-btn class="nexus-btn" @click="addItem('engineers', 'newEngineer')" block large>
                  <v-icon left>mdi-plus</v-icon>Add Engineer
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table class="nexus-table mb-8">
              <template v-slot:default>
                <thead><tr><th class="text-left">Name</th><th class="text-center" width="100">Action</th></tr></thead>
                <tbody>
                  <tr v-for="item in sorted('engineers')" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td class="text-center"><v-btn icon color="error" @click="removeItem('engineers', item.name)"><v-icon>mdi-delete</v-icon></v-btn></td>
                  </tr>
                  <tr v-if="engineers.length === 0"><td colspan="2" class="text-center grey--text">No engineers added</td></tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- Technicians Section -->
            <div class="section-header mb-4 mt-8">
              <h2 class="section-title">TECHNICIANS</h2>
              <div class="section-divider"></div>
            </div>
            <v-row class="mb-6">
              <v-col cols="12" md="8">
                <v-text-field v-model="newTechnician" label="Add Technician" dense outlined prepend-inner-icon="mdi-account-wrench" @keyup.enter="addItem('technicians', 'newTechnician')" class="nexus-input" />
              </v-col>
              <v-col cols="12" md="4">
                <v-btn class="nexus-btn" @click="addItem('technicians', 'newTechnician')" block large>
                  <v-icon left>mdi-plus</v-icon>Add Technician
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table class="nexus-table mb-8">
              <template v-slot:default>
                <thead><tr><th class="text-left">Name</th><th class="text-center" width="100">Action</th></tr></thead>
                <tbody>
                  <tr v-for="item in sorted('technicians')" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td class="text-center"><v-btn icon color="error" @click="removeItem('technicians', item.name)"><v-icon>mdi-delete</v-icon></v-btn></td>
                  </tr>
                  <tr v-if="technicians.length === 0"><td colspan="2" class="text-center grey--text">No technicians added</td></tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- Salespersons Section -->
            <div class="section-header mb-4 mt-8">
              <h2 class="section-title">SALESPERSONS</h2>
              <div class="section-divider"></div>
            </div>
            <v-row class="mb-6">
              <v-col cols="12" md="8">
                <v-text-field v-model="newSalesperson" label="Add Salesperson" dense outlined prepend-inner-icon="mdi-account-tie" @keyup.enter="addItem('salespersons', 'newSalesperson')" class="nexus-input" />
              </v-col>
              <v-col cols="12" md="4">
                <v-btn class="nexus-btn" @click="addItem('salespersons', 'newSalesperson')" block large>
                  <v-icon left>mdi-plus</v-icon>Add Salesperson
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table class="nexus-table mb-8">
              <template v-slot:default>
                <thead><tr><th class="text-left">Name</th><th class="text-center" width="100">Action</th></tr></thead>
                <tbody>
                  <tr v-for="item in sorted('salespersons')" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td class="text-center"><v-btn icon color="error" @click="removeItem('salespersons', item.name)"><v-icon>mdi-delete</v-icon></v-btn></td>
                  </tr>
                  <tr v-if="salespersons.length === 0"><td colspan="2" class="text-center grey--text">No salespersons added</td></tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- Lead Times Section -->
            <div class="section-header mb-4 mt-8">
              <h2 class="section-title">LEAD TIMES</h2>
              <div class="section-divider"></div>
            </div>
            <v-row class="mb-6">
              <v-col cols="12" md="8">
                <v-text-field v-model="newLeadTime" label="Add Lead Time (e.g., 1-2 DAYS, 3-5 WEEKS)" dense outlined prepend-inner-icon="mdi-clock" @keyup.enter="addLeadTime" class="nexus-input" />
              </v-col>
              <v-col cols="12" md="4">
                <v-btn class="nexus-btn" @click="addLeadTime" block large>
                  <v-icon left>mdi-plus</v-icon>Add Lead Time
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table class="nexus-table mb-8">
              <template v-slot:default>
                <thead><tr><th class="text-left">Lead Time</th><th class="text-center" width="100">Action</th></tr></thead>
                <tbody>
                  <tr v-for="(leadTime, index) in leadTimes" :key="index">
                    <td>{{ leadTime }}</td>
                    <td class="text-center"><v-btn icon color="error" @click="removeLeadTime(leadTime)"><v-icon>mdi-delete</v-icon></v-btn></td>
                  </tr>
                  <tr v-if="leadTimes.length === 0"><td colspan="2" class="text-center grey--text">No lead times added</td></tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- ── SAMPLES SECTION ── -->
            <div class="section-header mb-2 mt-10">
              <h2 class="section-title" style="color:#2e3a59;">SAMPLES — ASSIGNMENT LISTS</h2>
              <div class="section-divider"></div>
            </div>
            <p class="grey--text text--darken-1 mb-6" style="font-size:0.85rem;">
              These lists control the "Received By" and "Assigned To" dropdowns in the Sample Tracker at each status level.
            </p>

            <div v-for="sampleList in sampleLists" :key="sampleList.key" class="mb-8">
              <div class="section-header mb-4 mt-4">
                <h2 class="section-title" style="font-size:1rem;">{{ sampleList.label }}</h2>
                <div class="section-divider"></div>
              </div>
              <v-row class="mb-4">
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="sampleList.newValue"
                    :label="'Add to ' + sampleList.label"
                    dense outlined
                    prepend-inner-icon="mdi-account-plus"
                    @keyup.enter="addSampleListItem(sampleList)"
                    class="nexus-input"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn class="nexus-btn" @click="addSampleListItem(sampleList)" block large>
                    <v-icon left>mdi-plus</v-icon>Add
                  </v-btn>
                </v-col>
              </v-row>
              <v-simple-table class="nexus-table">
                <template v-slot:default>
                  <thead><tr><th class="text-left">Name</th><th class="text-center" width="100">Action</th></tr></thead>
                  <tbody>
                    <tr v-for="name in sampleList.items" :key="name">
                      <td>{{ name }}</td>
                      <td class="text-center">
                        <v-btn icon color="error" @click="removeSampleListItem(sampleList, name)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <tr v-if="sampleList.items.length === 0">
                      <td colspan="2" class="text-center grey--text">No entries added</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Save Button -->
            <v-row justify="center" class="mt-6">
              <v-btn large class="nexus-btn" @click="saveDropdowns" :disabled="saving">
                <v-icon left>mdi-content-save</v-icon>
                {{ saving ? 'Saving...' : 'Save All Changes' }}
              </v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar v-model="snackbar" color="success" timeout="3000">
      Dropdowns saved successfully!
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="errorSnackbar" color="error" timeout="3000">
      {{ errorMessage }}
      <v-btn color="white" text @click="errorSnackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { firebaseApp } from '@/firebaseConfig';

const db = getFirestore(firebaseApp);

const SAMPLE_LIST_DEFINITIONS = [
  { key: 'samplesReceivedBy',       label: 'Samples - Received By' },
  { key: 'samplesBooked',           label: 'Samples - Booked' },
  { key: 'samplesInspection',       label: 'Samples - Inspection' },
  { key: 'samplesDrawing',          label: 'Samples - Drawing' },
  { key: 'samplesPendingQuote',     label: 'Samples - Pending Quote' },
  { key: 'samplesQuoted',           label: 'Samples - Quoted' },
  { key: 'samplesToBeReturned',     label: 'Samples - To be Returned' },
  { key: 'samplesAtDispatch',       label: 'Samples - At Dispatch' },
  { key: 'samplesReturnCompleted',  label: 'Samples - Return Completed' },
];

export default {
  name: 'DropdownManager',
  data() {
    return {
      loading: false,
      saving: false,
      engineers: [],
      technicians: [],
      salespersons: [],
      leadTimes: [],
      newEngineer: '',
      newTechnician: '',
      newSalesperson: '',
      newLeadTime: '',
      snackbar: false,
      errorSnackbar: false,
      errorMessage: '',
      sampleLists: SAMPLE_LIST_DEFINITIONS.map(def => ({
        ...def,
        items: [],
        newValue: '',
      })),
    };
  },

  async created() {
    await this.fetchDropdowns();
  },

  methods: {
    sorted(listKey) {
      return [...this[listKey]].sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
      );
    },

    addItem(listKey, inputKey) {
      const val = this[inputKey].trim();
      if (val) {
        this[listKey].push({ name: val });
        this[inputKey] = '';
      }
    },

    removeItem(listKey, name) {
      this[listKey] = this[listKey].filter(e => e.name !== name);
    },

    addLeadTime() {
      if (this.newLeadTime.trim()) {
        const lt = this.newLeadTime.trim().toUpperCase();
        if (!this.leadTimes.includes(lt)) this.leadTimes.push(lt);
        this.newLeadTime = '';
      }
    },

    removeLeadTime(lt) {
      this.leadTimes = this.leadTimes.filter(l => l !== lt);
    },

    addSampleListItem(sampleList) {
      const val = sampleList.newValue.trim();
      if (val && !sampleList.items.includes(val)) {
        sampleList.items.push(val);
        sampleList.items.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
      }
      sampleList.newValue = '';
    },

    removeSampleListItem(sampleList, name) {
      sampleList.items = sampleList.items.filter(n => n !== name);
    },

    async fetchDropdowns() {
      try {
        this.loading = true;
        const dropdownDoc = await getDoc(doc(db, 'admin', 'dropdownManager'));
        if (dropdownDoc.exists()) {
          const data = dropdownDoc.data();
          this.engineers = data.engineers || [];
          this.technicians = data.technicians || [];
          this.salespersons = data.salespersons || [];
          this.leadTimes = data.leadTimes || [];
          this.sampleLists.forEach(sl => {
            sl.items = data[sl.key] || [];
          });
        }
      } catch (error) {
        this.showError('Failed to fetch dropdown options.');
      } finally {
        this.loading = false;
      }
    },

    async saveDropdowns() {
      try {
        this.saving = true;
        const sampleData = {};
        this.sampleLists.forEach(sl => {
          sampleData[sl.key] = sl.items;
        });
        await setDoc(
          doc(db, 'admin', 'dropdownManager'),
          {
            engineers: this.engineers,
            technicians: this.technicians,
            salespersons: this.salespersons,
            leadTimes: this.leadTimes,
            ...sampleData,
            lastUpdated: new Date().toISOString(),
          },
          { merge: true }
        );
        this.snackbar = true;
      } catch (error) {
        this.showError('Failed to save dropdown options.');
      } finally {
        this.saving = false;
      }
    },

    showError(msg) {
      this.errorMessage = msg;
      this.errorSnackbar = true;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.dropdown-manager-container {
  background: linear-gradient(135deg, #475569 0%, #334155 100%);
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
  padding: 20px;
}

.page-title {
  color: white;
  font-weight: 700;
  font-size: 2.5rem;
  text-align: center;
  letter-spacing: 2px;
  margin: 0;
}

.main-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.3);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  color: #475569;
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: 1px;
  margin: 0;
  white-space: nowrap;
}

.section-divider {
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, #475569 0%, rgba(71, 85, 105, 0.2) 100%);
  margin-left: 20px;
  border-radius: 1px;
}

.nexus-input >>> .v-input__slot {
  background: rgba(248, 250, 252, 0.8) !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  transition: all 0.3s ease;
}

.nexus-input >>> .v-input__slot:hover {
  border-color: #475569 !important;
  background: rgba(255, 255, 255, 0.9) !important;
}

.nexus-btn {
  background: linear-gradient(135deg, #475569 0%, #334155 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  text-transform: none !important;
  box-shadow: 0 4px 14px 0 rgba(71, 85, 105, 0.3) !important;
  transition: all 0.3s ease !important;
}

.nexus-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px 0 rgba(71, 85, 105, 0.4) !important;
}

.nexus-table {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.nexus-table >>> thead {
  background: linear-gradient(135deg, #475569 0%, #334155 100%);
}

.nexus-table >>> thead th {
  color: white !important;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 16px !important;
}

.nexus-table >>> tbody tr {
  transition: background-color 0.2s ease;
}

.nexus-table >>> tbody tr:hover {
  background-color: rgba(248, 250, 252, 0.8);
}

.nexus-table >>> tbody td {
  padding: 12px 16px !important;
}
</style>